// components/MarkdownTyper.jsx
import React, { useEffect, useRef, useState } from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";


function MarkdownTyper({
  text,
  chunk = 2,
  speed = 20,
  onComplete,
}) {
  const timerRef = useRef(null);
  const [displayed, setDisplayed] = useState("");

  useEffect(() => {
    if (timerRef.current) {
      clearInterval(timerRef.current);
      timerRef.current = null;
    }

    const units = segmentGraphemes(text ?? "");
    if (units.length === 0) {
      setDisplayed("");
      onComplete?.();
      return;
    }

    const firstChunk = units.slice(0, Math.max(1, chunk)).join("");
    setDisplayed(firstChunk);

    let index = Math.max(1, chunk);

    if (index >= units.length) {
      onComplete?.();
      return;
    }

    timerRef.current = setInterval(() => {
      const next = units.slice(index, index + Math.max(1, chunk)).join("");
      setDisplayed((prev) => prev + next);
      index += Math.max(1, chunk);

      if (index >= units.length) {
        clearInterval(timerRef.current);
        timerRef.current = null;
        onComplete?.();
      }
    }, Math.max(0, speed));

    return () => {
      if (timerRef.current) {
        clearInterval(timerRef.current);
        timerRef.current = null;
      }
    };
  }, [text, speed, chunk, onComplete]);

  return (
    <div className="markdown-content">
      <ReactMarkdown remarkPlugins={[remarkGfm]}>{displayed}</ReactMarkdown>
    </div>
  );
}

function segmentGraphemes(str) {
  if (typeof Intl !== "undefined" && Intl.Segmenter) {
    const seg = new Intl.Segmenter(undefined, { granularity: "grapheme" });
    return Array.from(seg.segment(str), (s) => s.segment);
  }
  return Array.from(str);
}

export default MarkdownTyper;